import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  actionWrapper: {
    background: theme.palette.bgV2.main,
    padding: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
    cursor: 'pointer',
  },
  actionContainer: {
    background: `linear-gradient(90deg, ${theme.palette.boxGradientColor.pink} 0%, ${theme.palette.boxGradientColor.orange} 48.6%, ${theme.palette.boxGradientColor.purple} 100%)`,
    position: 'relative',
    borderRadius: theme.spacing(0.25),
    height: theme.spacing(4),
    padding: theme.spacing(2.625, 2.5625),
    display: 'flex',
    alignItems: 'center',
  },
  actionLable: {
    color: theme.palette.textBlueV3.main,
    fontSize: '12px',
    lineHeight: '17.52px',
    fontWeight: 500,
  },
  tooltipWrapper: {
    maxWidth: theme.spacing(26.625),
    width: theme.spacing(26.625),
  },
  play: {
    height: theme.spacing(3.25),
    width: theme.spacing(3.25),
    borderRadius: '100%',
    position: 'absolute',
    margin: 'auto',
    background: '#00000020',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  videoWrapper: {
    background: theme.palette.bgV2.main,
    padding: theme.spacing(2),
    borderRadius: theme.spacing(0.8),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  largePlay: {
    height: theme.spacing(9.93),
    width: theme.spacing(9.93),
    cursor: 'pointer',
  },
}))
